import {useState} from "react";
import ChatHistory from "../../../../../../components/chat/chat-history.jsx";
import AttendanceInfoService from "../../../../../../services/reports/attendance-info-service.jsx";

export default function Chat({ title, id }) {
    const [chatStatus, setChatStatus] = useState(null);
    const chatUrl = AttendanceInfoService.getChat(id);

    if (!id) return null;

    if (chatStatus === "NOT_FOUND") {
        return null;
    }

    return (
        <div className="space-y-4 px-5">
            {chatStatus === "SUCCESS" && (
                <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                    {title}
                </h2>
            )}
            <div className="mx-auto w-full max-w-[60%] [&>*:first-child>*:first-child]:hidden [&>*:first-child>*:nth-child(2)]:h-auto! [&_.chat-body]:h-auto! [&_.chat-body]:max-h-[calc(100vh-205px)]">
                <ChatHistory
                    url={chatUrl}
                    title=""
                    height="h-auto"
                    dataCallback={(response) => {
                        setChatStatus(response?.status);
                    }}
                />
            </div>
        </div>
    )
}